@if (showLoadingComponent()) {
  <app-loading-page title="PARTNER CORE" [isLoading]="isLoading()"></app-loading-page>
}
<router-outlet></router-outlet>